import { render } from "./CompanyContent.vue?vue&type=template&id=51ccafb6&scoped=true"
import script from "./CompanyContent.vue?vue&type=script&lang=js"
export * from "./CompanyContent.vue?vue&type=script&lang=js"

import "./CompanyContent.vue?vue&type=style&index=0&id=51ccafb6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ccafb6"]])

export default __exports__